import {Injectable} from '@angular/core';
import {PagingApiService} from '@abstract/paging-api.service';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';

@Injectable()
export class TechnicalDeviceElementGroupsPagesService extends PagingApiService<TechnicalDeviceNamespace.ElementGroupInterface> {
    public deviceId: number;

    get pagingUrl(): string {
        return `technical-device/${this.deviceId}/element-group-pages`;
    }

    defaultItemsPerPage = 10;
}
